import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "align-left-h",
  "use": "align-left-h-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"align-left-h\"><path d=\"M15 8H5.667M3.333 13V3M10.333 12.667L5.667 8l4.666-4.667\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol